import { BooleanInput, Edit, SimpleForm, SaveButton } from 'react-admin';
import { Box, Toolbar, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CustomToolbar = () => {
  const navigate = useNavigate();

  return (
    <Toolbar>
      <SaveButton />
      <Button onClick={() => navigate(-1)} color="secondary">
        Cancel
      </Button>
    </Toolbar>
  );
};

export const UserEdit = () => {
  return (
    <Edit mutationMode="pessimistic" actions={false}>
      <SimpleForm toolbar={<CustomToolbar />}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 2,
          }}
        >
          <Box display="flex" flexDirection="column" gap={2}>
            <BooleanInput
              source="csbEnabled"
              label="Cashback redemption feature is enabled for this user"
              format={(value) => value === 1}
              parse={(value) => (value ? 1 : 0)}
            />
            <BooleanInput
              source="gcdEnabled"
              label="Gift Cards redemption feature is enabled for this user"
              format={(value) => value === 1}
              parse={(value) => (value ? 1 : 0)}
            />
          </Box>
        </Box>
      </SimpleForm>
    </Edit>
  );
};
